import Vue from 'vue';
import Vuex from 'vuex';
import VuexI18n from 'vuex-i18n';
import VuexPersistence from 'vuex-persist';
import authModule from './modules/auth.module';
import carouselModule from './modules/carousel.module';
import servicelineModule from './modules/serviceline.module';
import userModule from './modules/user.module';

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    authModule,
    carouselModule,
    servicelineModule,
    userModule
  },
  state(){
    return {
      msalConfig: {
        auth: {
          clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
          authority: process.env.VUE_APP_MSAL_LOGIN_AUTHORITY,
          redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
          postLogoutRedirectUri: process.env.VUE_APP_MSAL_POSTLOGOUT_REDIRECT_URI
        },
        cache: {
          cacheLocation: 'localStorage',
        },
      },
      accessToken: ''
    };
  },
  mutations :{
    setAccessToken(state, token){
      state.accessToken = token;
    }
  },
  plugins: [vuexLocal.plugin]
})

Vue.use(VuexI18n.plugin, store)

export default store
